
//import { pushState } from '../data/history';

let reducerMap = {};


export function registerReducer(name, value) {
	reducerMap[name] = value;
}

export function reduce(state, action) {
	let reducer = reducerMap[action.type];
	if (reducer) {
		const res = reducer(state, action);
/*		if (reducer.historyMode === 'push') {
			pushState(res);
		}*/
		return res;
	}
	return state;
}
